import React from 'react';

export default function Loading (props) {
    const inline = props.inline || false

    const content = (
        <h2>
            Loading...
        </h2>
    )

    if (inline) {
        return content
    }
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                        </div>
                        <div className="ibox-content">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
